/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingcreatedwithimages3Inputs */

const en_listingcreatedwithimages3 = /** @type {(inputs: Listingcreatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing created with images!`)
};

const de_listingcreatedwithimages3 = /** @type {(inputs: Listingcreatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort mit Bildern erstellt!`)
};

/**
* | output |
* | --- |
* | "Listing created with images!" |
*
* @param {Listingcreatedwithimages3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingcreatedwithimages3 = /** @type {((inputs?: Listingcreatedwithimages3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingcreatedwithimages3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingcreatedwithimages3(inputs)
	return de_listingcreatedwithimages3(inputs)
});
export { listingcreatedwithimages3 as "listingCreatedWithImages" }